import { useRef } from "react";
import { generateFillInTheGapsExercise } from "../utils/quizGenerator";

const parseFillInTheGapsCustomText = (text) => {
  const lines = text.split(/\n+/).filter(l => l.trim());
  return lines
    .map((line, idx) => {
      const firstGap = line.match(/\*\*(.+?)\*\*/)?.[1] || '';
      return firstGap ? { id: idx + 1, sentence: line.trim(), gap: firstGap } : null;
    })
    .filter(Boolean);
};

export function useFillInTheGapsGeneratorLogic({
  fillInTheGapsInput, setFillInTheGapsInput, fillInTheGapsLevel,
  setFillInTheGapsLoading, generatedFillInTheGaps, setGeneratedFillInTheGaps,
  fillInTheGapsCustomText, setFillInTheGapsCustomText, setFillInTheGapsMode,
  currentTab, activeEditor, onInsertToBoard,
  setShowFillInTheGapsGenerator, setSelectedTemplate,
}) {
  const fitgTextareaRef = useRef(null);

  const handleMarkGapInText = () => {
    const ta = fitgTextareaRef.current;
    if (!ta) return;
    const start = ta.selectionStart;
    const end = ta.selectionEnd;
    if (start === end) return;
    const selected = ta.value.substring(start, end).trim();
    if (!selected) return;
    const newVal = ta.value.substring(0, start) + `**${selected}**` + ta.value.substring(end);
    setFillInTheGapsCustomText(newVal);
    setTimeout(() => { ta.focus(); ta.setSelectionRange(start + 2, start + 2 + selected.length); }, 0);
  };

  const handleFillInTheGapsGenerate = async () => {
    if (!fillInTheGapsInput.trim()) return;

    setFillInTheGapsLoading(true);
    try {
      const exerciseData = await generateFillInTheGapsExercise(
        fillInTheGapsInput,
        fillInTheGapsLevel
      );
      setGeneratedFillInTheGaps(exerciseData);
    } catch (e) {
      alert(e?.message || 'Could not generate the exercise. Please try again.');
    } finally {
      setFillInTheGapsLoading(false);
    }
  };

  const handleFillInTheGapsInsertCustom = () => {
    const sentences = parseFillInTheGapsCustomText(fillInTheGapsCustomText);
    if (!sentences.length) return;
    const data = { sentences, title: 'Fill in the Gaps Exercise', level: fillInTheGapsLevel };
    if (currentTab === 0 && activeEditor) {
      activeEditor.chain().focus().insertFillInTheGapsExercise({ sentences: data.sentences, title: data.title, level: data.level }).run();
    } else {
      onInsertToBoard(data, 'fillinthegaps');
    }
    setShowFillInTheGapsGenerator(false);
    setFillInTheGapsCustomText('');
    setFillInTheGapsMode('generate');
    setSelectedTemplate(null);
  };

  const handleFillInTheGapsInsert = () => {
    if (!generatedFillInTheGaps) return;

    if (currentTab === 0 && activeEditor) {
      activeEditor.chain().focus().insertFillInTheGapsExercise({
        sentences: generatedFillInTheGaps.sentences,
        title: generatedFillInTheGaps.title,
        level: generatedFillInTheGaps.level
      }).run();
    } else {
      onInsertToBoard(generatedFillInTheGaps, 'fillinthegaps');
    }

    setShowFillInTheGapsGenerator(false);
    setFillInTheGapsInput("");
    setGeneratedFillInTheGaps(null);
    setSelectedTemplate(null);
  };

  const handleFillInTheGapsCancel = () => {
    setShowFillInTheGapsGenerator(false);
    setFillInTheGapsInput("");
    setFillInTheGapsCustomText('');
    setFillInTheGapsMode('generate');
    setGeneratedFillInTheGaps(null);
    setSelectedTemplate(null);
  };

  return {
    fitgTextareaRef, handleMarkGapInText,
    handleFillInTheGapsGenerate, handleFillInTheGapsInsertCustom,
    handleFillInTheGapsInsert, handleFillInTheGapsCancel,
  };
}
